"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttributes = exports.gtag = exports.getAttribute = exports.setAttribute = exports.sendEvent = exports.init = void 0;
const analytics_utils_1 = require("@missionlabs/analytics-utils");
const gtag_1 = __importDefault(require("./gtag"));
exports.gtag = gtag_1.default;
let haveAllProvidersBeenInitiated = false;
let providerInstances = [];
// This is the attributes that should be attached to all events
const attributes = {};
const getProviders = () => providerInstances;
const handleCommand = (command, ...data) => {
    if (!haveAllProvidersBeenInitiated) {
        console.warn('Please, initiate analytics providers first!');
        return;
    }
    executeCommand(command, ...data);
};
const executeCommand = (command, ...data) => getProviders().forEach((provider) => {
    provider[command](...data);
});
const sendEvent = (eventName, eventData) => {
    let eventParams;
    if (!(0, analytics_utils_1.isEmpty)(attributes)) {
        eventParams = Object.assign({}, attributes);
    }
    if (!(0, analytics_utils_1.isNilOrEmpty)(eventData)) {
        const params = eventParams || {};
        eventParams = Object.assign(Object.assign({}, params), eventData);
    }
    handleCommand('sendEvent', eventName, eventParams);
};
exports.sendEvent = sendEvent;
const setAttribute = (attrName, attrValue) => {
    attributes[attrName] = attrValue;
};
exports.setAttribute = setAttribute;
const getAttribute = (attrName) => {
    return attributes[attrName];
};
exports.getAttribute = getAttribute;
const getAttributes = () => {
    return attributes;
};
exports.getAttributes = getAttributes;
const init = (providers) => {
    const api = {
        getProviders,
    };
    if (haveAllProvidersBeenInitiated) {
        return api;
    }
    providerInstances = providers.map(({ provider, options }) => {
        return provider(options.id, options);
    });
    console.log('All providers have been initiated');
    haveAllProvidersBeenInitiated = true;
    return api;
};
exports.init = init;
